import React from 'react';
import './PageLoader.css';

const PageLoader: React.FC<{ text?: string }> = ({ text }) => {
  return (
    <div className="page-loader">
      <div className="page-loader-spinner">
        <div className="page-loader-spinner-ring"></div>
        <div className="page-loader-spinner-ring"></div>
        <div className="page-loader-spinner-ring"></div>
      </div>
      <p className="page-loader-text">{text ?? 'Загрузка...'}</p>
    </div>
  );
};

export default PageLoader;
